import React, { Component } from "react";
import { connect } from "react-redux";

//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
import GoToLogin    from "../Components/component_GoToLogin";
import InputIcon    from "../Components/component_IconInput";
import FilterChip   from "../Components/component_FilterChips";
import BuyVersion   from "../Components/component_BuyVersion";
import SGButtonsBar from "../Components/component_SGButtonsBar";
//COMPONENTI MATERIAL UI
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import RaisedButton                          from "material-ui/RaisedButton";
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import DatePicker                            from "material-ui/DatePicker";
import TextField                             from "material-ui/TextField";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";
//ACTIONS
import { getListaImpiantiTupla, getListaImpianti } from "../Actions/Action_ServiceRequest_Impianti";
import { getHoldingList }        from "../Actions/Action_ServiceRequest_Holding";
import { getListaAziendeTupla }  from "../Actions/Action_ServiceRequest_Azienda";
import { getListaStampanti, orderListaStampanti, getListaModelliStampanti, getListaMarcheStampanti, setStampante }     from "../Actions/Action_ServiceRequest_Stampanti";
import { checkPortForm, checkIntIDForm, checkIpv4Form, checkStrForm } from "../Utils/Check_Value";
import { getUserInfo } from "../Actions/Action_Authentication";
//Utils
import * as ROLES  from "../Utils/Roles_Types.js";
import * as STYLES from "../Utils/Styles.js";
//ICON
import IconArrowUp   from "material-ui/svg-icons/navigation/arrow-drop-up";
import IconArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import IconFilter    from "material-ui/svg-icons/content/filter-list";
import IconEdit      from "material-ui/svg-icons/editor/mode-edit";
import IconAdd       from "material-ui/svg-icons/content/add";
import IconDelete    from "material-ui/svg-icons/action/delete";
import IconShow      from "material-ui/svg-icons/image/remove-red-eye";
import IconFormat    from "material-ui/svg-icons/editor/format-shapes";
import IconRefresh   from "material-ui/svg-icons/navigation/refresh";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import { LABEL_Required, LABEL_NoResult, LABEL_Filters, LABEL_Close, LABEL_Cancel, LABEL_Save, LABEL_Name, LABEL_Model, LABEL_Brand, LABEL_Printer,LABEL_Confirm, LABEL_DIALOG_DELETE_Body,
         LABEL_Ip, LABEL_Port, LABEL_Plant, LABEL_OrderBy, LABEL_Choose_Plant, LABEL_Choose_Company, LABEL_Choose_Holding, LABEL_Choose_Tipology,
        LABEL_Choose_Model, LABEL_Choose_Brand, LABEL_Enter_Name, LABEL_Enter_Ip, LABEL_Enter_Port, LABEL_DIALOG_PrinterNew, LABEL_DIALOG_PrinterModify, 
         LABEL_DIALOG_PrinterDetail, LABEL_ALERT_Choose_Plant_Printer, LABEL_Delete, LABEL_PAGE_Printer} from "../Utils/Strings/Labels";
import ConfirmDialog from "../Components/component_ConfirmDialog";
import { checkUserLanguage } from "../Utils/Check_Value";

var TIMER = null;
const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.ID;
const USERIDAZIENDA = USERINFO == null ? null: USERINFO.Azienda == null ? null : USERINFO.Azienda.ID;
const USERLANGUAGE  = checkUserLanguage(USERINFO);
const CANUSEPAGE    = !(!!USERINFO) ? false :  !(USERINFO.Role.ID === ROLES.ACCOUNT_FREE_ID || USERINFO.Role.ID === ROLES.ACCOUNT_PRO_ID);

const styles = {
  propContainer: {
    width: 200,
    overflow: "hidden",
    margin: "20px auto 0"
  },
  filterDialog: {
    width: "100%",
    maxWidth: "none"
  },
  filterRow: {
    marginBottom: "20px"
  }
};

var emptyStampanteModel = {
  ID       : null,
  Nome     : null, 
  Ip       : null, 
  Porta    : null, 
  Impianto : {
    ID : null, 
    Nome : null
  },
  Cancellata : {
    Cancellata     : null,
    CancellataDa   : null, 
    CancellataData : null
  },
  Modello : {
    ID : null,
    Marca : {
      ID : null
    }
  },
}

class Stampanti extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      //Table
      fixedHeader: true,
      fixedFooter: true,
      stripedRows: false,
      showRowHover: true,
      selectable: true,
      multiSelectable: false,
      enableSelectAll: false,
      deselectOnClickaway: false,
      showCheckboxes: false,
      height: '700px',
      selectedList : [],
      //SORT
      ordinaPer : null,
      //FILTER
      filter : {
        Porta : null,
        IDModello : null,
        Porta : null, 
        IDImpianto : null,
        Nome : null, 
        Ip : null,
        Cancellata : false,
        IDAzienda  : USERIDAZIENDA,
        IDHolding  : USERIDHOLDING,
      },
      filterHolding : {
        ID                 : null,
        Nome               : null,
        Descrizione        : null,
        DataInizioScadenza : null,
        DataFineScadenza   : null
      },
      filterDialog : {
        opened : false,
        data   : null //Lo utilizzo per salvare i movimenti nella dialog cosi che se vengono annullati rimane tutto come prima
      },
      filterModelliStampanti : {
        ID      : null,
        Modello : null,
        Marca   : null,
        PortaPredefinita : null
      },
      filterMarcheStampanti : {
        ID : null, 
        Marca : null
      },
      //Modal per aggiungere o modificare
      showAddModify : {
        opened : false,
        data   : JSON.parse(JSON.stringify(emptyStampanteModel)),
        modify : true
      },
      alertDialog : {
        title   : null,
        style   : { maxWidth: "50%" },
        opened  : false,
        message : null,
        fnClose : () => {var aD = this.state.alertDialog; aD.opened = false; this.setState({alertDialog : aD})},
      },
      selezioneManuale : true,
      filterChipsList : []
    }
  }

  isSelectedRow      = index => this.state.selectedList.indexOf(index) !== -1;
  handleRowSelection = row   => this.setState({ selectedList : row });
  
  handleOrderChange = (event, index, value) => {
    this.setState({ordinaPer : value});
    this.props.dispatch(orderListaStampanti(this.props.stampantiList, value));
  };
  
  setTimerForText = () => {
    if(TIMER != null)
      clearTimeout(TIMER);
    TIMER = setTimeout(() => {
      this.props.dispatch(getListaStampanti(this.state.filter));
    }, 500);
  };

  //Per intercettare il cambio di filtri testuali
  handleOnFilterTextChange = (value, position, label) => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[position] = value;
    filterChips[position] = {position : position, value : value, label : label };
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  };

  handleChangeHolding = (event, index, value) => {
    var selectedHolding = this.state.filter;
    selectedHolding.IDHolding = value;
    selectedHolding.IDAzienda = null;
    this.setState({ filter: selectedHolding }); 
    this.props.dispatch(getListaAziendeTupla(selectedHolding.ID));
  };

  handleChangeAzienda = (event, index, value) => {
    var selectedAzienda = this.state.filter;
    selectedAzienda.IDAzienda  = value;
    selectedAzienda.IDImpianto = null;
    this.setState({ filter: selectedAzienda });
    this.props.dispatch(getListaImpiantiTupla(this.state.filter.IDHolding, selectedAzienda.IDAzienda));
  };

  handleChangeImpianto = (event, index, value) => {
    var selectedImpianto = this.state.filter;
    selectedImpianto.IDImpianto = value;
    this.setState({ filter: selectedImpianto });
    this.props.dispatch(getListaStampanti(this.state.filter));
  };

  
  componentDidMount(){
    if(!CANUSEPAGE) return;
    this.props.dispatch(getUserInfo());
    //se si e' un amministratore is bisogna prima selezionare la holding
    if(this.state.filter.IDHolding === null){
      this.props.dispatch(getHoldingList(this.state.filterHolding));
    }else if(this.state.filter.IDAzienda === null){
      this.props.dispatch(getListaAziendeTupla(this.state.filter.IDHolding));
    }else{
      this.props.dispatch(getListaImpiantiTupla(this.state.filter.IDHolding, this.state.filter.IDAzienda));
    }
  };

  handleOpenAddModifyOnlyRead = () => {
    this.handleOpenAddModify(true);
  }
  handleOpenAddModify = (modify = false) => {
    var showAddModify = this.state.showAddModify;
    if(this.state.selectedList.length === 1){
      showAddModify.data = JSON.parse(JSON.stringify(this.props.stampantiList[this.state.selectedList[0]]));
      this.props.dispatch(getListaModelliStampanti(this.state.filterMarcheStampanti));
    }else{
      //Se non e' stata selezionato un impianto allora mando l'alert
      if(this.state.filter.IDImpianto == null ){
        var alertDialog     = this.state.alertDialog;
        alertDialog.title   = LABEL_Choose_Plant[USERLANGUAGE];
        alertDialog.message = LABEL_ALERT_Choose_Plant_Printer[USERLANGUAGE];
        alertDialog.opened  = true;
        this.setState({alertDialog : alertDialog});
        return;
      }
      showAddModify.data = JSON.parse(JSON.stringify(emptyStampanteModel));
      showAddModify.data.Impianto.ID = this.state.filter.IDImpianto;
    }
    showAddModify.opened = true;
    showAddModify.modify = modify;
    //prendo i filtri per la lista dei modelli
    this.props.dispatch(getListaMarcheStampanti(this.state.filterMarcheStampanti));
    //prendo i filtri per i modelli solo se e' stato impostata gia la marca
    if(showAddModify.data.Modello.ID !== null ){
      var filterModelli = this.state.filterModelliStampanti;
      filterModelli.IDMarca = showAddModify.data.Modello.Marca.ID;
      this.props.dispatch(getListaModelliStampanti(filterModelli));
    }
    this.setState({showAddModify : showAddModify});
  };
  handleCloseAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = false;
    this.setState( { showAddModify : showAddModify } );
  };
  handleCloseAddModifyWithSave = () => {
    //Controllo i campi
    var flag = true;
    var showAddModify = this.state.showAddModify;
    //NOME
    showAddModify.data.msgErrorNome       = checkStrForm(showAddModify.data.Nome);
      if( showAddModify.data.msgErrorNome != null ) flag = false;
    //IP
    showAddModify.data.msgErrorIp         = checkIpv4Form(showAddModify.data.Ip);
      if(showAddModify.data.msgErrorIp != null ) flag = false;
    //PORT
    showAddModify.data.msgErrorPorta      = checkPortForm(showAddModify.data.Porta);
      if(showAddModify.data.msgErrorPorta != null ) flag = false;
    //MODELLO
    showAddModify.data.msgErrorModello    = checkIntIDForm(showAddModify.data.Modello.ID);
      if(showAddModify.data.msgErrorModello != null) flag = false;
    //MARCA
    showAddModify.data.msgErrorMarca    = checkIntIDForm(showAddModify.data.Modello.Marca.ID);
      if(showAddModify.data.msgErrorMarca != null) flag = false;
    
    if(showAddModify.data.Holding == null || showAddModify.data.Holding.ID === null) //Forzo l'holding (cosi da non perdere traccia del campo aggiunto)
      showAddModify.data.Holding = USERINFO.Holding;
    if(flag){
      showAddModify.opened = false;
      this.props.dispatch(setStampante(showAddModify.data));//mando al servizio i dati
      setTimeout(() => this.props.dispatch(getListaStampanti(this.state.filter)), 150);//ricarico la lista
    }else this.setState( { showAddModify : showAddModify } );
  };
  handleAddModifyMarcaChange = (event, index, value) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.Modello.Marca.ID = value;
    this.setState({ showAddModify: showAddModify });
    //Aggiorno la lista dei modelli in base alla marca
    var modelliFilter = this.state.filterModelliStampanti;
    modelliFilter.IDMarca = value;
    this.props.dispatch(getListaModelliStampanti(modelliFilter));
  }
  handleAddModifyModelloChange = (event, index, value) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.Modello.ID = value;
    this.setState({ showAddModify: showAddModify });
  }
  handleOnChangeAddModifyText = (value, position) => {
    var showAddModify = this.state.showAddModify;
    if(value == null || value.trim() == ""){
      showAddModify.data["msgError"+position] = LABEL_Required[USERLANGUAGE];
    }else showAddModify.data["msgError"+position] = "";
    showAddModify.data[position] = value;
    this.setState( { showAddModify : showAddModify } );
  }
  
  handleDeleteButton = () => this.setState({showDeleteDialog: true})

  _deleteRow = () => {
    if(this.state.selectedList[0] > this.props.stampantiList.length){
      this.setState({selectedList : []});
      return;
    }
    var item = this.props.stampantiList[this.state.selectedList[0]];
        item.Cancellata = { Cancellata : true};
    var newState = {
      showDeleteDialog : false, //Chiudo la dialog
    }
    if (this.state.selectedList[0] == this.props.stampantiList.length -1) // se era l'ultimo
       newState["selectedList"] = [];
    this.setState(newState);
    this.props.dispatch(setStampante(item));
    setTimeout( () => this.props.dispatch(getListaStampanti(this.state.filter)), 150 ) ;
  }

  handleGotoStampe = () =>{
    PAGESSWITCH.gotoPageWithParams("/stampe", {IDAzienda: this.state.filter.IDAzienda})
  }

  onDeleteChips = chip => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[chip.position] = null;
    filterChips[chip.position] = null;
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  }
  
  componentWillReceiveProps(newProps){
    if(newProps.aziendeList.length === 1){
      var filter = this.state.filter;
      var SelezioneManuale = this.state.selezioneManuale;
      filter.IDAzienda = newProps.aziendeList[0].ID;
      if(SelezioneManuale){
        SelezioneManuale = false;
        this.props.dispatch(getListaImpiantiTupla(filter.IDHolding, filter.IDAzienda));
      }
      this.setState({filter:filter, selezioneManuale: SelezioneManuale});
    }
  }

  render(){

    var alertDialogAction = [ <RaisedButton label={LABEL_Close[USERLANGUAGE]} primary={true} onClick={this.state.alertDialog.fnClose} /> ];

    var modifyPermission = USERINFO != null && USERINFO.Role.ID != ROLES.OPERATOR_ID;
    
    //Tasti per la dialog aggiungi/modifica
    var addModifyDialogAction = null;
    
    if(this.state.showAddModify.modify == true){
      addModifyDialogAction = [
      <RaisedButton
        label={LABEL_Close[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseAddModify}
      />,
    ];
    }else{
      addModifyDialogAction = [
        <RaisedButton
          label={LABEL_Cancel[USERLANGUAGE]}
          primary={false}
          onClick={this.handleCloseAddModify}
        />,
        <RaisedButton
          label={LABEL_Save[USERLANGUAGE]}
          primary={true}
          onClick={this.handleCloseAddModifyWithSave}
      />];
    }

    var buttonBarList = [];
    if(modifyPermission){
      buttonBarList = [
        { //AGGIUNGI
          icon     : <IconAdd />, 
          onClick  : this.handleOpenAddModify,
          disabled : this.state.selectedList.length > 0 ,
        },
        { //MODIFICA
          icon     : <IconEdit />, 
          onClick  : this.handleOpenAddModify,
          disabled : this.state.selectedList.length !== 1,
        },
        { //ELIMINA
          icon     : <IconDelete />, 
          onClick  : this.handleDeleteButton,
          disabled : this.state.selectedList.length < 1,
        },
        {//SETTA STAMPE
          icon    : <IconFormat />,
          onClick : this.handleGotoStampe
        }
      ]
      
    }
    buttonBarList.push({ //VISUALIZZA DETTAGLIO
      icon:<IconShow />, 
      onClick  : this.handleOpenAddModifyOnlyRead,
      disabled : this.state.selectedList.length !== 1
    });
    buttonBarList.push({ //REFRESH
      icon     : <IconRefresh />, 
      onClick  : () => this.props.dispatch(getListaStampanti(this.state.filter))
    });

    /*AGGIUNGI
                      modifyPermission && <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconAdd />} onClick={this.handleOpenAddModify} disabled={this.state.selectedList.length !== 0} />
                        </Col>}
                      {//MODIFICA
                      modifyPermission && <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconEdit />} onClick={this.handleOpenAddModify} disabled={this.state.selectedList.length !== 1} />
                        </Col>}
                      {//ELIMINA
                      modifyPermission && <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconDelete />} onClick={this.handleDeleteButton} disabled={this.state.selectedList.length < 1} />
                        </Col>}
                      {//VISUALIZZA DETTAGLIO
                        <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconShow />} onClick={this.handleOpenAddModifyOnlyRead} disabled={this.state.selectedList.length !== 1} />
                        </Col>}
                      {//SETTA STAMPE
                      modifyPermission && <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconFormat />} onClick={this.handleGotoStampe} />
                        </Col>}
                      <Col sm12={1}>
                        <RaisedButton className="button-table" icon={<IconRefresh />} onClick={() => this.props.dispatch(getListaStampanti(this.state.filter))} />
                      </Col>*/

      return <div>
          <Menu dispatch={this.props.dispatch} pageName={LABEL_PAGE_Printer[USERLANGUAGE]} Language={USERLANGUAGE} />
          <ErrorMessage message={this.props.errorMessage} />
          <GoToLogin isAuthenticated={this.props.isAuthenticated} />
          <BuyVersion 
            visible={!CANUSEPAGE}
            Language={USERLANGUAGE}/>
          <div className="my-body">
            {<Grid>
                <Row>
                  {USERIDHOLDING == null && <Col sm12={3}>
                      <SelectField floatingLabelText={LABEL_Choose_Holding[USERLANGUAGE]} value={this.state.filter.IDHolding} onChange={this.handleChangeHolding}>
                        {this.props.holdingList && this.props.holdingList.map(
                            holding => (
                              <MenuItem
                                key={holding.ID}
                                value={holding.ID}
                                primaryText={holding.Nome}
                              />
                            )
                          )}
                      </SelectField>
                    </Col>}
                  {this.state.filter.IDHolding != null && (USERINFO.Role.ID === ROLES.ADMINISTRATOR_IS_ID || USERINFO.Role.ID === ROLES.ADMINISTRATOR_HOLDING_ID) && <Col sm12={3}>
                        <SelectField floatingLabelText={LABEL_Choose_Company[USERLANGUAGE]} value={this.state.filter.IDAzienda} onChange={this.handleChangeAzienda} disabled={this.props.aziendeList.length == 1}>
                          <MenuItem key={null} value={null} primaryText={""} />
                          {this.props.aziendeList && this.props.aziendeList.map(
                              azienda => (
                                <MenuItem
                                  key={azienda.ID}
                                  value={azienda.ID}
                                  primaryText={azienda.Nome}
                                />
                              )
                            )}
                        </SelectField>
                      </Col>}
                  {this.state.filter.IDAzienda != null && <Col sm12={3}>
                      <SelectField floatingLabelText={LABEL_Choose_Plant[USERLANGUAGE]} value={this.state.filter.IDImpianto} onChange={this.handleChangeImpianto}>
                        <MenuItem key={null} value={null} primaryText={""} />
                        {this.props.impiantiList && this.props.impiantiList.map(
                            impianto => (
                              <MenuItem
                                key={impianto.ID}
                                value={impianto.ID}
                                primaryText={impianto.Nome}
                              />
                            )
                          )}
                      </SelectField>
                    </Col>}
                </Row>
              </Grid>}

            {this.state.filter.IDImpianto != null && <div>
                <Grid>
                  <Row style={styles.filterRow}>
                    <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                      <InputIcon icon={<IconFilter />} className="input-label" onChange={event => this.handleOnFilterTextChange(event.target.value, "Nome", LABEL_Name[USERLANGUAGE])} hintText={LABEL_Enter_Name[USERLANGUAGE]} floatingLabelText={LABEL_Name[USERLANGUAGE]} value={this.state.filter.Nome == null ? "" : this.state.filter.Nome} />
                    </Col>
                    <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                      <InputIcon icon={<IconFilter />} className="input-label" onChange={event => this.handleOnFilterTextChange(event.target.value, "Ip", LABEL_Ip[USERLANGUAGE])} hintText={LABEL_Enter_Ip[USERLANGUAGE]} floatingLabelText={LABEL_Ip[USERLANGUAGE]} value={this.state.filter.Ip == null ? "" : this.state.filter.Ip} />
                    </Col>
                    <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                      <InputIcon icon={<IconFilter />} className="input-label" onChange={event => this.handleOnFilterTextChange(event.target.value, "Porta", LABEL_Port[USERLANGUAGE])} hintText={LABEL_Enter_Port[USERLANGUAGE]} floatingLabelText={LABEL_Port[USERLANGUAGE]} type="number" value={this.state.filter.Porta == null ? "" : this.state.filter.Porta} />
                    </Col>
                    <Col xs4={4} sm12={6} lg12={3} xl12={3}>
                      <SelectField floatingLabelText={LABEL_OrderBy[USERLANGUAGE]} value={this.state.ordinaPer} onChange={this.handleOrderChange}>
                        <MenuItem value={"Impianto.Nome"} primaryText={LABEL_Plant[USERLANGUAGE]} rightIcon={<IconArrowUp />} />
                        <MenuItem value={"Impianto.NomeDESC"} primaryText={LABEL_Plant[USERLANGUAGE]} rightIcon={<IconArrowDown />} />
                        <MenuItem value={"Ip"} primaryText={LABEL_Ip[USERLANGUAGE]} rightIcon={<IconArrowUp />} />
                        <MenuItem value={"IpDESC"} primaryText={LABEL_Ip[USERLANGUAGE]} rightIcon={<IconArrowDown />} />
                        <MenuItem value={"Modello.Marca.Nome"} primaryText={LABEL_Brand[USERLANGUAGE]} rightIcon={<IconArrowUp />} />
                        <MenuItem value={"Modello.Marca.NomeDESC"} primaryText={LABEL_Brand[USERLANGUAGE]} rightIcon={<IconArrowDown />} />
                        <MenuItem value={"Modello.Modello"} primaryText={LABEL_Model[USERLANGUAGE]} rightIcon={<IconArrowUp />} />
                        <MenuItem value={"Modello.ModelloDESC"} primaryText={LABEL_Model[USERLANGUAGE]} rightIcon={<IconArrowDown />} />
                        <MenuItem value={"Porta"} primaryText={LABEL_Port[USERLANGUAGE]} rightIcon={<IconArrowUp />} />
                        <MenuItem value={"PortaDESC"} primaryText={LABEL_Port[USERLANGUAGE]} rightIcon={<IconArrowDown />} />
                        <MenuItem value={"Nome"} primaryText={LABEL_Name[USERLANGUAGE]} rightIcon={<IconArrowUp />} />
                        <MenuItem value={"NomeDESC"} primaryText={LABEL_Name[USERLANGUAGE]} rightIcon={<IconArrowDown />} />
                      </SelectField>
                    </Col>
                  </Row>
                  {USERINFO != null && <Row>
                      <SGButtonsBar list={buttonBarList}/>
                    </Row>}
                </Grid>

                <FilterChip list={this.state.filterChipsList} onDelete={this.onDeleteChips} />

                <Table className="shadow" height={window.innerHeight - 500} fixedHeader={this.state.fixedHeader} fixedFooter={this.state.fixedFooter} selectable={this.state.selectable} multiSelectable={this.state.multiSelectable} onRowSelection={this.handleRowSelection}>
                  <TableHeader displaySelectAll={this.state.showCheckboxes} adjustForCheckbox={this.state.showCheckboxes} enableSelectAll={this.state.enableSelectAll}>
                    <TableRow>
                      <TableHeaderColumn style={{ width: "20%" }} tooltip="">
                        {" "}
                        {LABEL_Name[USERLANGUAGE] + " " + LABEL_Printer[USERLANGUAGE]}{" "}
                      </TableHeaderColumn>
                      <TableHeaderColumn style={{ width: "15%" }} tooltip="">
                        {" "}
                        {LABEL_Ip[USERLANGUAGE]}{" "}
                      </TableHeaderColumn>
                      <TableHeaderColumn style={{ width: "15%" }} tooltip="">
                        {" "}
                        {LABEL_Port[USERLANGUAGE]}{" "}
                      </TableHeaderColumn>
                      <TableHeaderColumn style={{ width: "15%" }} tooltip="">
                        {" "}
                        {LABEL_Model[USERLANGUAGE]}{" "}
                      </TableHeaderColumn>
                      <TableHeaderColumn style={{ width: "15%" }} tooltip="">
                        {" "}
                        {LABEL_Brand[USERLANGUAGE]}{" "}
                      </TableHeaderColumn>
                      <TableHeaderColumn style={{ width: "20%" }} tooltip="">
                        {" "}
                        {LABEL_Plant[USERLANGUAGE]}{" "}
                      </TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={this.state.showCheckboxes} deselectOnClickaway={this.state.deselectOnClickaway} showRowHover={this.state.showRowHover} stripedRows={this.state.stripedRows}>
                    {this.props.stampantiList != null && this.props.stampantiList.map(
                        (row, index) => (
                          <TableRow
                            key={index}
                            selected={this.isSelectedRow(index)}
                          >
                            <TableRowColumn style={{ width: "15%" }}>
                              {" "}
                              {row.Nome}{" "}
                            </TableRowColumn>
                            <TableRowColumn style={{ width: "15%" }}>
                              {" "}
                              {row.Ip}{" "}
                            </TableRowColumn>
                            <TableRowColumn style={{ width: "15%" }}>
                              {" "}
                              {row.Porta}{" "}
                            </TableRowColumn>
                            <TableRowColumn style={{ width: "15%" }}>
                              {" "}
                              {row.Modello.Modello}{" "}
                            </TableRowColumn>
                            <TableRowColumn style={{ width: "15%" }}>
                              {" "}
                              {row.Modello.Marca.Nome}{" "}
                            </TableRowColumn>
                            <TableRowColumn style={{ width: "15%" }}>
                              {" "}
                              {row.Impianto.ID}{" "}
                            </TableRowColumn>
                          </TableRow>
                        )
                      )}
                    {this.props.stampantiList != null && this.props.stampantiList.length == 0 && <TableRow selectable={false} hoverable={false} hovered={false} selectable={false} striped={false}>
                          <TableRowColumn>
                            <center>
                              {LABEL_NoResult[USERLANGUAGE]}
                            </center>
                          </TableRowColumn>
                        </TableRow>}
                  </TableBody>
                </Table>
              </div>}

            <Dialog title={this.state.selectedList.length === 0 ? LABEL_DIALOG_PrinterNew[USERLANGUAGE] : this.state.showAddModify.modify === true ? LABEL_DIALOG_PrinterDetail[USERLANGUAGE] : LABEL_DIALOG_PrinterModify[USERLANGUAGE]} actions={addModifyDialogAction} modal={true} contentStyle={styles.filterDialog} open={this.state.showAddModify.opened}>
              <Grid>
                <Row>
                  <Col sm12={2} />
                  <Col sm12={8} xs4={4}>
                    <TextField className="input-label" onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Nome")} hintText={LABEL_Enter_Name[USERLANGUAGE]} floatingLabelText={LABEL_Name[USERLANGUAGE]} fullWidth={true} errorText={this.state.showAddModify.data.msgErrorNome} fullWidth={true} disabled={this.state.showAddModify.modify == true ? true : false} value={this.state.showAddModify.data.Nome === null ? "" : this.state.showAddModify.data.Nome} />
                  </Col>
                  <Col sm12={2} />
                </Row>
                <Row>
                  <Col sm12={2} />
                  <Col sm12={3} xs4={4}>
                    <TextField className="input-label" onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Ip")} hintText={LABEL_Enter_Ip[USERLANGUAGE]} floatingLabelText={LABEL_Ip[USERLANGUAGE]} fullWidth={true} errorText={this.state.showAddModify.data.msgErrorIp} fullWidth={true} disabled={this.state.showAddModify.modify == true ? true : false} value={this.state.showAddModify.data.Ip === null ? "" : this.state.showAddModify.data.Ip} />
                  </Col>
                  <Col sm12={2} />
                  <Col sm12={3} xs4={4}>
                    <TextField className="input-label" onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Porta")} hintText={LABEL_Enter_Port[USERLANGUAGE]} floatingLabelText={LABEL_Port[USERLANGUAGE]} fullWidth={true} type="number" errorText={this.state.showAddModify.data.msgErrorPorta} fullWidth={true} disabled={this.state.showAddModify.modify == true ? true : false} value={this.state.showAddModify.data.Porta === null ? "" : this.state.showAddModify.data.Porta} />
                  </Col>
                  <Col sm12={2} />
                </Row>

                <Row>
                  <Col sm12={2} />
                  <Col sm12={3} xs4={4}>
                    <SelectField floatingLabelText={LABEL_Choose_Brand[USERLANGUAGE]} value={this.state.showAddModify.data == null ? null : this.state.showAddModify.data.Modello.Marca.ID} onChange={this.handleAddModifyMarcaChange} errorText={this.state.showAddModify.data.msgErrorMarca} fullWidth={true} disabled={this.state.showAddModify.modify == true ? true : false}>
                      <MenuItem value={null} primaryText={""} />
                      {this.props.stampantiMarcheList && this.props.stampantiMarcheList.map(
                          marca => (
                            <MenuItem
                              key={marca.ID}
                              value={marca.ID}
                              primaryText={marca.Nome}
                            />
                          )
                        )}
                    </SelectField>
                  </Col>
                  <Col sm12={2} />
                  <Col sm12={3} xs4={4}>
                    <SelectField floatingLabelText={LABEL_Choose_Model[USERLANGUAGE]} value={this.state.showAddModify.data == null ? null : this.state.showAddModify.data.Modello.ID} onChange={this.handleAddModifyModelloChange} errorText={this.state.showAddModify.data.msgErrorModello} fullWidth={true} disabled={this.state.showAddModify.modify == true ? true : false}>
                      <MenuItem value={null} primaryText={""} />
                      {this.props.stampantiModelliList && this.props.stampantiModelliList.map(
                          modello => (
                            <MenuItem
                              key={modello.ID}
                              value={modello.ID}
                              primaryText={modello.Modello}
                            />
                          )
                        )}
                    </SelectField>
                  </Col>
                  <Col sm12={2} />
                </Row>
              </Grid>
            </Dialog>

            <Dialog title={this.state.alertDialog.title} actions={alertDialogAction} modal={true} contentStyle={this.state.alertDialog.style} open={this.state.alertDialog.opened}>
              {this.state.alertDialog.message}
            </Dialog>

            <ConfirmDialog title={LABEL_Delete[USERLANGUAGE] + " " + LABEL_Printer[USERLANGUAGE] + ": " + (this.state.selectedObj && this.state.selectedObj.Nome)} opened={this.state.showDeleteDialog} confirmLabel={LABEL_Confirm[USERLANGUAGE]} cancelLabel={LABEL_Cancel} onCancel={() => this.setState(
                  { showDeleteDialog: false }
                )} body={LABEL_DIALOG_DELETE_Body[USERLANGUAGE] + "" + (this.state.selectedObj && this.state.selectedObj.Nome)} onConfirm={this._deleteRow} />
          </div>
        </div>;
  }

  
}

function mapStateToProps(state) {
  const { stampantiReducer } = state;
  const { isFetching, isAuthenticated, impiantiList, errorMessage, holdingList, aziendeList, stampantiList, stampantiMarcheList, stampantiModelliList } = stampantiReducer;
  return {
    isFetching,
    impiantiList,
    isAuthenticated,
    errorMessage,
    holdingList,
    aziendeList,
    stampantiList,
    stampantiMarcheList,
    stampantiModelliList
  };
}

export default connect(mapStateToProps)(Stampanti);


// WEBPACK FOOTER //
// ./src/Containers/Stampanti.js